<template>
  <div>
    <el-card>
      <el-tabs v-model="activeTab" @tab-click="handleClick">
        <el-tab-pane label="待办" name="first"> </el-tab-pane>
        <el-tab-pane label="已办" name="second"> </el-tab-pane>
        <el-tab-pane label="已失效" name="third"> </el-tab-pane>
        <div class="tab-common">
          <!-- 年份选择 -->
          <div class="rowpart">
            <el-date-picker
              style="width: 200px"
              v-model="year"
              type="year"
              placeholder="选择年"
              value-format="YYYY"
            >
            </el-date-picker>
          </div>

          <!-- 季度选择 -->
          <div class="rowpart">
            <SeasonSelect
              v-model="season"
              @season="this.season = $event"
            ></SeasonSelect>
          </div>
        </div>

        <div>
          <el-table
            :data="EvaEventsData"
            style="width: 100%"
            height="600"
            ref="multipleTable"
            @selection-change="handleSelectionChange"
            :default-sort="{ prop: 'id' }"
            row-key="id"
          >
            <template v-for="column in EvaEventsTable" :key="column.label">
              <el-table-column
                :prop="column.prop"
                :label="column.label"
                width="180"
                :formatter="formatter"
              >
              </el-table-column>
            </template>
            <el-table-column label="操作" width="200" fixed="right">
              <template #default="scope">
                <el-button
                  v-if="activeTab == 'first'"
                  size="mini"
                  @click="handleEva(scope.$index, scope.row)"
                  type="text"
                  >评定</el-button
                >
                <el-button v-else size="mini" type="text">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tabs>
    </el-card>
    <!-- common items over writing -->
    <el-dialog v-model="showableComp.showCommonEvaTable" width="90%">
      <div class="text-group">
        <div>考核周期：{{ this.year + "年  " + this.season }}</div>
        <div>共性指标评价表</div>
      </div>
      <el-table
        :data="tableData2"
        border
        style="width: 100%"
        height="600"
        row-key="userId"
        @cell-click="cellClick"
        v-loading="loading"
      >
        <el-table-column prop="userId" label="序号" fixed />
        <el-table-column prop="userName" label="名称" fixed />
        <el-table-column
          prop="departmentName"
          label="所属科室"
          fixed
          width="100px"
        />
        <template v-for="(column2, index2) in normItems" :key="column2.normId">
          <el-table-column
            :label="column2.normName + '(' + column2.normScore + ')'"
          >
            <template
              v-for="(column3, index3) in column2.children"
              :key="column3.normId"
            >
              <el-table-column
                :label="column3.normName + '(' + column3.normScore + ')'"
                width="240"
              >
                <template #default="scope">
                  <RatioGroup
                    :scoreArr="normRateArr[index2][index3].rateScores"
                    :rateArr="normRateArr[index2][index3].rateNames"
                    @radio="acceptScore(scope.$index, $event, index2, index3)"
                  />
                </template>
              </el-table-column>
            </template>
          </el-table-column>
        </template>
        <!-- <el-table-column label="政治标准(32)">
          <el-table-column prop="c1" label="政治忠诚(12)" width="240">
            <template #default="scope">
              <RatioGroup
                :scoreArr="[12, 9, 6, 3]"
                @radio="this.tableData2[scope.$index].c1 = $event"
              />
            </template>
          </el-table-column>
          <el-table-column prop="c2" label="政治定力(12)" width="240">
            <template #default="scope">
              <RatioGroup
                :scoreArr="[12, 9, 6, 3]"
                @radio="this.tableData2[scope.$index].c2 = $event"
              />
            </template>
          </el-table-column>
          <el-table-column prop="c3" label="政治能力(12)" width="240">
            <template #default="scope">
              <RatioGroup
                :scoreArr="[12, 9, 6, 3]"
                @radio="this.tableData2[scope.$index].c3 = $event"
              />
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="政治要求(48)">
          <el-table-column prop="c4" label="思想建设(12)" width="240">
            <template #default="scope">
              <RatioGroup
                :scoreArr="[12, 9, 6, 3]"
                @radio="this.tableData2[scope.$index].c4 = $event"
              />
            </template>
          </el-table-column>
          <el-table-column prop="c5" label="组织纪律(12)" width="240">
            <template #default="scope">
              <RatioGroup
                :scoreArr="[12, 9, 6, 3]"
                @radio="this.tableData2[scope.$index].c5 = $event"
              />
            </template>
          </el-table-column>
          <el-table-column prop="c6" label="道德品质(12)" width="240">
            <template #default="scope">
              <RatioGroup
                :scoreArr="[12, 9, 6, 3]"
                @radio="this.tableData2[scope.$index].c6 = $event"
              />
            </template>
          </el-table-column>
          <el-table-column prop="c7" label="廉洁自律(12)" width="240">
            <template #default="scope">
              <RatioGroup
                :scoreArr="[12, 9, 6, 3]"
                @radio="this.tableData2[scope.$index].c7 = $event"
              />
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="工作作风(16)">
          <el-table-column prop="c8" label="工作态度(8)" width="240">
            <template #default="scope">
              <RatioGroup
                :scoreArr="[8, 6, 4, 2]"
                @radio="this.tableData2[scope.$index].c8 = $event"
              />
            </template>
          </el-table-column>
          <el-table-column prop="c9" label="工作纪律(8)" width="240">
            <template #default="scope">
              <RatioGroup
                :scoreArr="[8, 6, 4, 2]"
                @radio="this.tableData2[scope.$index].c9 = $event"
              />
            </template>
          </el-table-column>
        </el-table-column> -->
        <el-table-column prop="totalScore" label="总分" width="120">
        </el-table-column>
      </el-table>
      <div class="btn-group">
        <el-button type="primary" @click="onCal">统计计算</el-button>
        <el-popconfirm
          title="确认提交?（提交后不可修改）"
          @confirm="onSubmit"
          confirm-button-text="是"
          cancel-button-text="否"
        >
          <template #reference>
            <el-button type="primary">提交</el-button>
          </template>
        </el-popconfirm>
        <!-- <el-button type="primary" @click="onSubmit">提交</el-button> -->
      </div>
    </el-dialog>

    <!-- 共性指标评价 -->
    <!-- <el-dialog v-model="showableComp.showCommonEvaTable" width="90%">
      <div class="text-group">
        <div>考核周期：</div>
        <div>评价表</div>
        <div>考核开始时间</div>
      </div>
      <el-table
        :data="tableData2"
        border
        style="width: 100%"
        height="600"
        :default-sort="{ prop: 'userId' }"
        row-key="userId"
      >
        <el-table-column prop="userId" label="序号" fixed />
        <el-table-column prop="userName" label="名称" fixed />
        <el-table-column prop="departmentName" label="所属科室" />
        <el-table-column label="政治标准(32)">
          <el-table-column prop="c1" label="政治忠诚(12)" width="240">
            <template #default="scope">
              <RatioGroup
                :scoreArr="[12, 9, 6, 3]"
                @radio="this.tableData2[scope.$index].c1 = $event"
              />
            </template>
          </el-table-column>
          <el-table-column prop="c2" label="政治定力(12)" width="240">
            <template #default="scope">
              <RatioGroup
                :scoreArr="[12, 9, 6, 3]"
                @radio="this.tableData2[scope.$index].c2 = $event"
              />
            </template>
          </el-table-column>
          <el-table-column prop="c3" label="政治能力(12)" width="240">
            <template #default="scope">
              <RatioGroup
                :scoreArr="[12, 9, 6, 3]"
                @radio="this.tableData2[scope.$index].c3 = $event"
              />
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="政治要求(48)">
          <el-table-column prop="c4" label="思想建设(12)" width="240">
            <template #default="scope">
              <RatioGroup
                :scoreArr="[12, 9, 6, 3]"
                @radio="this.tableData2[scope.$index].c4 = $event"
              />
            </template>
          </el-table-column>
          <el-table-column prop="c5" label="组织纪律(12)" width="240">
            <template #default="scope">
              <RatioGroup
                :scoreArr="[12, 9, 6, 3]"
                @radio="this.tableData2[scope.$index].c5 = $event"
              />
            </template>
          </el-table-column>
          <el-table-column prop="c6" label="道德品质(12)" width="240">
            <template #default="scope">
              <RatioGroup
                :scoreArr="[12, 9, 6, 3]"
                @radio="this.tableData2[scope.$index].c6 = $event"
              />
            </template>
          </el-table-column>
          <el-table-column prop="c7" label="廉洁自律(12)" width="240">
            <template #default="scope">
              <RatioGroup
                :scoreArr="[12, 9, 6, 3]"
                @radio="this.tableData2[scope.$index].c7 = $event"
              />
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="工作作风(16)">
          <el-table-column prop="c8" label="工作态度(8)" width="240">
            <template #default="scope">
              <RatioGroup
                :scoreArr="[8, 6, 4, 2]"
                @radio="this.tableData2[scope.$index].c8 = $event"
              />
            </template>
          </el-table-column>
          <el-table-column prop="c9" label="工作纪律(8)" width="240">
            <template #default="scope">
              <RatioGroup
                :scoreArr="[8, 6, 4, 2]"
                @radio="this.tableData2[scope.$index].c9 = $event"
              />
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column prop="totalScore" label="总分" width="120">
        </el-table-column>
      </el-table>
      <div class="btn-group">
        <el-button type="primary" @click="onCal">统计计算</el-button>
        <el-button type="primary" @click="onSubmit">提交</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import EvaEvents from "../api/EvaEvents";
export default EvaEvents;
</script>

<style scoped lang="scss">
.tab-common {
  display: flex;
  margin-bottom: 20px;
}
.rowpart {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.text-group {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.btn-group {
  display: flex;
  justify-content: end;
  margin-top: 10px;
}
</style>